import { initSplitApi } from './init'
import * as q from './elastic-query'

export const orgAPI = initSplitApi.injectEndpoints({
    reducerPath: 'org',
    endpoints: (builder) => ({
        orgCreate: builder.mutation({
            query: (body) => {
                return {
                    url: `orgs/_doc/${body.id}`,
                    method: 'PUT',
                    service: 'elastic',
                    body
                };
            },
            providesTags: ['orgList']
        }),
        orgCognito: builder.mutation({
            query: (params) => ({
                url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/org/create`,
                method: 'POST',
                body: params,
                service: 'amplify'
            }),
            providesTags: ['orgCognito']
        }),
        orgEdit: builder.mutation({
            query: (body) => {
                console.log(body)
                return {
                    url: `orgs/_update/${body.doc.id}`,
                    method: 'POST',
                    service: 'elastic',
                    body
                };
            },
            providesTags: ['orgList']
        }),
        orgDelete: builder.mutation({
            query: (params) => {
                return {
                    url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/org/delete`,
                    method: 'POST',
                    body: params,
                    service: 'amplify'
                };
            },
            providesTags: ['userList']
        }),
        orgList: builder.query({
            query: (params) => ({
                url: `orgs/_search`,
                method: 'POST',
                body: q.getOrgListQuery(params.criteria),
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['orgList']
        }),
        orgQList: builder.query({
            query: (params) => ({
                url: `orgs/_search`,
                method: 'POST',
                body: params.q,
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['orgList']
        }),
        disableOrg: builder.mutation({
            query: (params) => ({
                url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/org/disable`,
                method: 'POST',
                body: params,
                service: 'amplify'
            }),
            providesTags: ['orgList']
        }),
        orgChangePassword: builder.mutation({
            query: (params) => ({
                url: `https://vlct3i7u6a.execute-api.us-west-2.amazonaws.com/prod/org/reset/password`,
                method: 'POST',
                body: params,
                service: 'amplify'
            }),
            providesTags: ['orgList']
        }),
        orgDetails: builder.query({
            query: (params) => ({
                url: `orgs/_search`,
                method: 'POST',
                body: {
                    "query": {
                        "bool": {
                            "must": [
                                {
                                    "match": { "id.keyword": params.id }
                                }
                            ]
                        }
                    }
                },
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    return response.hits.hits[0]._source;
                }
            },
            providesTags: ['orgList']
        }),
    }),

    overrideExisting: false
})

export const {
    useOrgCognitoMutation,
    useDisableOrgMutation,
    useOrgChangePasswordMutation,
    useOrgCreateMutation,
    useOrgDeleteMutation,
    useOrgEditMutation,
    useOrgDetailsQuery,
    useOrgQListQuery,
    useOrgListQuery
} = orgAPI